export interface Localization {
  key: string
  template: string
}

interface LocalizationSerializerInput {
  key?: string
  template?: string
  value?: string
}

export function LocalizationSerializer(
  input: LocalizationSerializerInput,
): Localization {
  return {
    key: input.key ?? "",
    template: input.template || input.value || "",
  }
}
